import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 35 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "35",
      height: "32",
      fill: "#fff",
      rx: "8"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#484848",
      d: "M20.816 9.946H9.139c-.716 0-1.297.58-1.297 1.297v9.514c0 .717.58 1.297 1.297 1.297h11.677c.716 0 1.297-.58 1.297-1.297v-9.514c0-.717-.58-1.297-1.297-1.297ZM27.158 11.675v8.65a.435.435 0 0 1-.216.376.437.437 0 0 1-.432 0l-3.244-1.869v-5.665l3.244-1.868a.451.451 0 0 1 .432 0 .435.435 0 0 1 .216.376Z"
    }, null, -1)
  ]))]))
}
export default { render: render }